/** PM Typing Indicators — WebSocket typing/newmessage event handlers. */

// Typing indicator state: maps thread_id → { timeout, originalSnippetHtml }
const typingIndicators = {};
// Header typing indicator state for the active thread
let headerTypingState = null;

document.addEventListener('thread:typing', function(e) {
  const threadId = e.detail.thread_id;
  const typingText = window.t ? window.t('legacy.pm.typing') : 'Typing...';

  // Update thread list snippet — save original so we can restore on timeout
  const threadEl = document.getElementById('thread_' + threadId);
  if (threadEl) {
    const snippetSpan = threadEl.querySelector('.th_snippet .truncate');
    if (snippetSpan) {
      if (!typingIndicators[threadId] || typingIndicators[threadId].originalSnippetHtml == null) {
        typingIndicators[threadId] = typingIndicators[threadId] || {};
        typingIndicators[threadId].originalSnippetHtml = snippetSpan.innerHTML;
      }
      snippetSpan.innerHTML = '<em class="text-sky-500 typing-indicator">' + window.escapeHtml(typingText) + '</em>';
    }
  }

  // Update header status if this is the active thread
  const activeThreadId = window.get_active_thread_id ? window.get_active_thread_id() : null;
  if (activeThreadId === threadId) {
    const statusEl = document.getElementById('current_thread_status');
    if (statusEl) {
      if (!headerTypingState) {
        headerTypingState = { originalText: statusEl.textContent };
      }
      statusEl.textContent = typingText;
      statusEl.classList.add('text-sky-500');
      statusEl.classList.remove('text-gray-400');
    }
  }

  // Clear previous timeout and set a new one
  if (typingIndicators[threadId]) {
    clearTimeout(typingIndicators[threadId].timeout);
  } else {
    typingIndicators[threadId] = {};
  }
  typingIndicators[threadId].timeout = setTimeout(function() {
    // Restore snippet only if it still contains our typing indicator.
    // If the thread list was re-rendered by update_pm_info, the snippet
    // already has fresh server content — don't overwrite with stale cache.
    var el = document.getElementById('thread_' + threadId);
    if (el && typingIndicators[threadId] && typingIndicators[threadId].originalSnippetHtml != null) {
      var span = el.querySelector('.th_snippet .truncate');
      if (span && span.querySelector('.typing-indicator')) {
        span.innerHTML = typingIndicators[threadId].originalSnippetHtml;
      }
    }
    delete typingIndicators[threadId];

    // Restore header status if still the active thread
    var currentActive = window.get_active_thread_id ? window.get_active_thread_id() : null;
    if (currentActive === threadId && headerTypingState) {
      var statusEl = document.getElementById('current_thread_status');
      if (statusEl) {
        statusEl.textContent = headerTypingState.originalText;
        statusEl.classList.remove('text-sky-500');
        statusEl.classList.add('text-gray-400');
      }
      headerTypingState = null;
    }
  }, 3000);
});

document.addEventListener('thread:newmessage', function(e) {
  const threadId = e.detail.thread_id;
  if (typingIndicators[threadId]) {
    clearTimeout(typingIndicators[threadId].timeout);
    // Restore snippet if typing indicator is still visible in the DOM
    var el = document.getElementById('thread_' + threadId);
    if (el && typingIndicators[threadId].originalSnippetHtml != null) {
      var span = el.querySelector('.th_snippet .truncate');
      if (span && span.querySelector('.typing-indicator')) {
        span.innerHTML = typingIndicators[threadId].originalSnippetHtml;
      }
    }
    delete typingIndicators[threadId];
  }
  // Clear header typing if it was for this thread
  const activeThreadId = window.get_active_thread_id ? window.get_active_thread_id() : null;
  if (activeThreadId === threadId && headerTypingState) {
    const statusEl = document.getElementById('current_thread_status');
    if (statusEl) {
      statusEl.textContent = headerTypingState.originalText;
      statusEl.classList.remove('text-sky-500');
      statusEl.classList.add('text-gray-400');
    }
    headerTypingState = null;
  }
});
